(function($) {
    $(document).ready(function() {
        var $jobsModal = $('#jobs-application-modal');

        function syncJobField($modal, jobTitle) {
            $modal.find('.wpcf7 form').each(function() {
                var $form = $(this);
                var $field = $form.find('[name="job"]');
                var $wrapper;

                if (!$field.length) {
                    return;
                }

                $field.val(jobTitle);
                $field.attr('type', 'hidden');
                $field.attr('readonly', 'readonly');
                $field.attr('aria-hidden', 'true');

                $wrapper = $field.closest('p');

                if (!$wrapper.length) {
                    $wrapper = $field.closest('.wpcf7-form-control-wrap');
                }

                $wrapper.addClass('is-hidden-job-field');
            });
        }

        function openModal($modal) {
            if (!$modal.length) {
                return;
            }

            $modal.attr('aria-hidden', 'false').fadeIn();
            $('body').addClass('modal-open');
        }

        function closeModal($modal) {
            if (!$modal.length) {
                return;
            }

            $modal.attr('aria-hidden', 'true').fadeOut(function() {
                if (!$('.modal:visible').length) {
                    $('body').removeClass('modal-open');
                }
            });
        }

        $(document).on('click', '.js-open-job-application', function(event) {
            var $item = $(this).closest('.jobs__item');
            var jobTitle = $.trim($item.find('.js-job-title').text());
            var jobDescription = $item.find('.js-job-description').html() || '';

            event.preventDefault();

            if (!$jobsModal.length) {
                return;
            }

            $jobsModal.find('.js-job-modal-title').text(jobTitle);
            $jobsModal.find('.js-job-modal-description').html(jobDescription);
            syncJobField($jobsModal, jobTitle);

            openModal($jobsModal);
        });

        $(document).on('click', '.open-modal', function(event) {
            var modalId;

            if ($(this).hasClass('js-open-job-application')) {
                return;
            }

            modalId = $(this).data('modal-id');
            event.preventDefault();

            if (!modalId) {
                return;
            }

            openModal($('#' + modalId));
        });

        $(document).on('click', '.close', function() {
            var modalId = $(this).data('modal-id');

            if (!modalId) {
                closeModal($(this).closest('.modal'));
                return;
            }

            closeModal($('#' + modalId));
        });

        $(window).on('click', function(event) {
            if ($(event.target).hasClass('modal')) {
                closeModal($(event.target));
            }
        });

        $(document).on('keydown', function(event) {
            if (event.key === 'Escape') {
                closeModal($('.modal:visible').last());
            }
        });
    });
})(jQuery);